<template>
  <div class="page-content" style="padding-top: 10px">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <button class="btn btn-rounded btn-primary" @click="printSoal()" id="print" style="margin-top: 20px"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
          <button @click="changeHideAnswer()" v-if="hideAnswer" class="btn btn-rounded btn-primary" id="print" style="margin-top: 20px"><i class="fa fa-eye" aria-hidden="true"></i> Tampilkan Jawaban</button>
          <button @click="changeHideAnswer()" v-else class="btn btn-rounded btn-primary" id="print" style="margin-top: 20px"><i class="fa fa-eye-slash" aria-hidden="true"></i> Sembunyikan Jawaban</button>
          <hr />
          <h2 class="text-center">Kuis {{ questionOverview.name }}</h2>
          <h5>Modul&emsp;&emsp;&emsp;&emsp; : {{ questionOverview.modul_name }}</h5>
          <h5>Mata Pelajaran&nbsp; : {{ questionOverview.subject_name }}</h5>
          <section class="card card-default" v-for="(soal, index) in questionOverview.list_soal" :key="index">
            <div class="container">
              <h5 class="with-border">
                Nomor {{ index + 1 }}<span class="float-right">{{ index + 1 }} / {{ questionOverview.list_soal.length }}</span>
              </h5>
              <hr />
              <img v-if="soal.file_path" class="img-center-200" width="100" :src="soal.file_path" alt="Logo" />
              <p id="soal"></p>
              <p>{{ soal.question }}</p>
              <div class="checkbox" v-for="(pilihan, index2) in soal.options" :key="index2">
                <i v-if="pilihan.is_answer == 1 && !hideAnswer" class="fas fa-circle"></i>
                <i v-else class="far fa-circle"></i>
                <label style="margin-left: 4px">
                  <p>{{ pilihan.choice }}</p>
                  <img v-if="pilihan.file_path" class="sticky-img-200" width="100" :src="pilihan.file_path" alt="Logo" />
                </label>
              </div>
            </div>
          </section>
        </div>
      </div>
      <!--.row-->
    </div>
    <!--.container-fluid-->
  </div>
  <!--.page-content-->
</template>
<style lang="css" scoped>
@media print {
  #print {
    display: none;
  }
}
.card-default {
  margin-bottom: 20px;
}
.card {
  background-color: #f8e8e8;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 100%;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.container {
  padding: 2px;
}
.with-border {
  padding-top: 20px;
}
</style>
<script>
import { mapGetters } from "vuex";
export default {
  props: {},
  components: {},
  data() {
    return {
      quizId: this.$route.params.quizId,
      hideAnswer: true,
      data: {},
    };
  },
  computed: {
    ...mapGetters({
      questionOverview: "getQuestionOverview",
    }),
  },
  watch: {},
  methods: {
    printSoal() {
      window.print();
    },
    changeHideAnswer() {
      if (this.hideAnswer) {
        this.hideAnswer = false;
      } else {
        this.hideAnswer = true;
      }
    },
    async getQuestionOverview(quizId) {
      await this.$store
        .dispatch("getQuestionOverview", { quizId })
        .then(() => {})
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  created() {
    this.getQuestionOverview(this.quizId);
  },
};
</script>
